import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ActivationPage from 'gatsby-theme-carbon/src/templates/ActivationPage';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`IBM Garage Method for Cloud`}</h2>
    <h3>{`(`}<a parentName="h3" {...{
        "href": "https://www.ibm.com/garage/method/cloud"
      }}>{`https://www.ibm.com/garage/method/cloud`}</a>{`)`}</h3>
    <p>{`The IBM Garage Method for Cloud is IBM’s approach to enable business, development, and operations to continuously design, deliver, and validate new solutions leveraging cloud technologies. The practices and workflows provide prescriptive guidance for cloud adoption and transformation, and you can adapt them to your company’s specific cloud journey and culture.`}</p>
    <p>{`The Method is industry-recognized and represents a unique, holistic IBM point-of-view and describes the complete cloud adoption and transformation lifecycle with enhancements that support the enterprise at scale. The result is a method that is proven, aligned with industry best practices, and scalable to any size engagement.`}</p>
    <p>
    Use the following links to help you deep dive in IBM Cloud Garage development best practices
    </p>
    <br></br>
    <ActivationPage content="gmd" mdxType="ActivationPage">
    </ActivationPage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      